import script from "./THeaderLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./THeaderLogo.vue?vue&type=script&setup=true&lang=ts"

import "./THeaderLogo.vue?vue&type=style&index=0&id=83303a66&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83303a66"]])

export default __exports__